import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const ease = [0.22, 1, 0.36, 1];
const fade = (d) => ({ initial: { opacity: 0, y: 14 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.8, delay: d, ease } });

export const Hero = ({ t, go, lang }) => (
  <section id="hero" data-testid="hero-section" className="bg-white pt-32 pb-16 lg:pt-44 lg:pb-20">
    <div key={lang} className="mx-auto flex max-w-4xl flex-col items-center px-6 text-center">
      <motion.h1
        {...fade(0.2)}
        data-testid="hero-main-title"
        className="font-serif text-4xl font-semibold leading-[1.1] text-[#0F2137] sm:text-5xl lg:text-6xl"
        style={{ fontWeight: 600 }}
      >
        {t.hero.lines.join(" ")}
      </motion.h1>
      <motion.div {...fade(0.3)} className="mt-8 h-px w-16 bg-[#0F2137]" />
      <motion.p {...fade(0.4)} className="mt-8 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">
        {t.hero.lead}
      </motion.p>
      <motion.div {...fade(0.5)} className="mt-10 flex flex-wrap justify-center gap-4">
        <button data-testid="hero-cta-practice" onClick={() => go("practice")} className="btn-primary group">
          {t.hero.cta} <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
        <button data-testid="hero-cta-contact" onClick={() => go("contact")} className="btn-outline">{t.hero.cta2}</button>
      </motion.div>
    </div>
  </section>
);
